/*
 * サブシステム名：OTM受付一覧編集
 * 機能名：受付一覧編集
 */
import flowMixin from '@/mixins/flowMixins'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

import date from '@/ddv2.library/date'

// import { mapGetters } from 'vuex'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
const DdDateBox = () => import('@/components/DdDateBox')
const DdNumericBox = () => import('@/components/DdNumericBox')

export default {
  name: 'OtmScheduler',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdDateBox,
    DdNumericBox
  },
  data: () => ({
    viewTitleX: '配送ボード',
    conditions: {},
    targets: [],
    events: [],

    // 内部処理用
    targetCountLists: [1, 2, 3, 4, 5],
    weekDayStrJP: ['日', '月', '火', '水', '木', '金', '土'],

    // 制御用
    modeKengen: 0
  }),
  watch: {
    conditions: {
      handler: function (s) {
        if (![undefined, null, ''].includes(s.baseYmd)) {
          this.setShowTarget()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredCol0 () {
      const self = this
      return this.events.filter((x) => {
        return x.ymd === self.targets[0]
      })
    },
    filteredCol1 () {
      const self = this
      return this.events.filter((x) => {
        return x.ymd === self.targets[0]
      })
    },
    filteredCol2 () {
      const self = this
      return this.events.filter((x) => {
        return x.ymd === self.targets[0]
      })
    },
    filteredCol3 () {
      const self = this
      return this.events.filter((x) => {
        return x.ymd === self.targets[0]
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initSettings()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('OtmDeliveryLedger.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('OtmDeliveryLedger.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('OtmDeliveryLedger.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    initSettings: function () {
      this.$set(this.conditions, 'baseYmd', date.getCurrentDate())
      this.conditions.dispCount = 5

      this.setShowTarget()

      this.headers = [
        { text: '場所', value: 'memo1', width: '20%' },
        { text: '商品', value: 'memo2', width: '30%' },
        { text: '顧客', value: 'memo3', width: '30%' },
        { text: '担当', value: 'memo4', width: '10%' },
        { text: '区分', value: 'kbn', width: '10%', align: 'center' }
      ]
      this.events = [
        {
          id: 1,
          ymd: '2025/01/29',
          memo1: 'OTM工場→法人課',
          memo2: 'ピクシスエポック 0050635　シルバー',
          memo3: '医療法人ＨＳＲ名嘉村クリニック',
          memo4: '比嘉',
          kbn: '新'
        },
        {
          id: 2,
          ymd: '2025/01/29',
          memo1: 'OTM工場→法人課',
          memo2: 'ピクシスエポック 0050636　シルバー',
          memo3: '医療法人ＨＳＲ名嘉村クリニック',
          memo4: '比嘉',
          kbn: '新'
        },
        {
          id: 3,
          ymd: '2025/01/29',
          memo1: 'OTM工場→法人課',
          memo2: 'ノア 0050635　シルバー',
          memo3: '〇山×郎',
          memo4: '又吉',
          kbn: '中'
        },
        {
          id: 11,
          ymd: '2025/01/30',
          memo1: 'OTM工場→法人課',
          memo2: 'ピクシスエポック 0050650　シルバー',
          memo3: 'ｚｚｚ',
          memo4: '比嘉',
          kbn: '新'
        },
        {
          id: 12,
          ymd: '2025/01/30',
          memo1: 'OTM工場→法人課',
          memo2: 'ノア 0050640　シルバー',
          memo3: '〇山×郎',
          memo4: '比嘉',
          kbn: '中'
        },
        {
          id: 41,
          ymd: '2025/01/31',
          memo1: 'OTM工場→法人課',
          memo2: 'ピクシスエポック 0050660　シルバー',
          memo3: 'ｘｘｘ',
          memo4: '又吉',
          kbn: '新'
        }
      ]
    },
    calcBaseDate: function (val) {
      if (val === null) {
        this.conditions.baseYmd = date.getCurrentDate()
      } else {
        const tmpDate = new Date(this.conditions.baseYmd)
        const currentDate = new Date(tmpDate)
        currentDate.setDate(tmpDate.getDate() + val)
        this.conditions.baseYmd = `${currentDate.getFullYear()}/${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getDate()).padStart(2, '0')}`
      }
    },
    setShowTarget: function () {
      // 対象指定欄が入力の場合は処理しない
      if ([undefined, null, ''].includes(this.conditions.baseYmd) || [undefined, null, ''].includes(this.conditions.dispCount)) return

      // 文字列をDateオブジェクトに変換
      const startDate = new Date(this.conditions.baseYmd)
      // 5日分の日付を格納する配列
      this.targets = []
      // 5日間の日付を生成
      for (let i = 0; i < this.conditions.dispCount; i++) {
        // 日付を計算
        const currentDate = new Date(startDate)
        currentDate.setDate(startDate.getDate() + i)
        // yyyy/mm/dd形式にフォーマット
        const formattedDate = `${currentDate.getFullYear()}/${String(currentDate.getMonth() + 1).padStart(2, '0')}/${String(currentDate.getDate()).padStart(2, '0')}`
        // 配列に追加
        this.targets.push(formattedDate)
      }
    },
    filteredCol: function (val) {
      const self = this
      return this.events.filter((x) => {
        return x.ymd === self.targets[val]
      })
    },
    getCount: function (val, kbn) {
      const self = this
      const w = this.events.filter((x) => {
        return x.ymd === self.targets[val] && ((kbn === null && !['新', '中', '下'].includes(x.kbn)) || x.kbn === kbn)
      })
      return w !== null ? w.length : 0
    },
    getWeekDay: function (d) {
      var dx = dayjs(d)
      return '(' + this.weekDayStrJP[dx.day()] + ')'
    },
    row_color_class: function (item) {
      if (item.memo4.indexOf('比嘉') >= 0) {
        return 'orange-event'
      } else if (item.memo4.indexOf('又吉') >= 0) {
        return 'yellow-event'
      }

      return ''
    },

    onDummyFunction: function () {
    }
  }
}
